<template>
  <tr>
    <td style="width: 160px; vertical-align: middle; word-break: break-word">
      <el-tooltip
        placement="top"
      >
        <div slot="content">{{ product.name }}</div>
      </el-tooltip>
      {{ product.name }}
    </td>
    <td>
      <el-form-item
        style="margin-top: -3px; margin-bottom: 0"
        :error="priceError.purchase_price"
      >
        <el-input-localized-numeric
          v-model="product.purchase_price"
          size="small"
          @input="isPriceValid('purchase_price')"
        />
      </el-form-item>
    </td>
    <td>
      <el-form-item
        :error="priceError.price"
        style="margin-top: -3px; margin-bottom: 0"
      >
        <el-input-localized-numeric
          v-model="product.price"
          size="small"
          @input="isPriceValid('price')"
        />
      </el-form-item>
    </td>
    <td>
      <el-form-item
        style="margin-top: -3px; margin-bottom: 0"
        :error="priceError.minimum_price"
      >
        <el-input-localized-numeric
          v-model="product.minimum_price"
          @input="isPriceValid('minimum_price')"
          size="small"
        />
      </el-form-item>
    </td>
    <td>
      <el-form-item
        style="margin-top: -3px; margin-bottom: 0"
        :error="priceError.retailer_price"
      >
        <el-input-localized-numeric
          v-model="product.retailer_price"
          size="small"
          @input="isPriceValid('retailer_price')"
        />
      </el-form-item>
    </td>
    <td>
      <el-form-item
        style="margin-top: -3px; margin-bottom: 0"
        :error="priceError.web_price"
      >
        <el-input-localized-numeric
          v-model="product.web_price"
          size="small"
          @input="isPriceValid('web_price')"
        />
      </el-form-item>
    </td>
  </tr>
</template>

<script>
  export default
  {
    props: ['productPrice',],
    data() {
      return {
        product: {
          name: '',
          price: null,
          minimum_price: null,
          retailer_price: null,
          web_price: null,
          purchase_price: null
        },
        priceError: {
          price: '',
          minimum_price: '',
          retailer_price: '',
          web_price: '',
          purchase_price: ''
        }
      };
    },
    mounted() {
      this.product = JSON.parse(JSON.stringify(this.productPrice));
    },
    methods: {
      isChanged() {
        return parseFloat(this.product.price) !== parseFloat(this.productPrice.price)
          || parseFloat(this.product.minimum_price) !== parseFloat(this.productPrice.minimum_price)
          || parseFloat(this.product.retailer_price) !== parseFloat(this.productPrice.retailer_price)
          || parseFloat(this.product.web_price) !== parseFloat(this.productPrice.web_price)
          || parseFloat(this.product.purchase_price) !== parseFloat(this.productPrice.purchase_price);
      },
      isPriceValid(prop) {
        if ((this.product[prop] !== null && this.product[prop] !== '' && isNaN(parseFloat(this.product[prop])) || (typeof this.product[prop] === 'string' && !this.product[prop].match(/^\d*\.?\d*?$/)))) {
          this.$set(this.priceError, prop, 'Csak szám lehet');
          return false;
        }
        this.priceError[prop] = '';
        return true;
      },
      isAllPriceValid() {
        return !this.priceError.price && !this.priceError.minimum_price && !this.priceError.retailer_price && !this.priceError.web_price && !this.priceError.purchase_price;
      }
      }
    }

</script>
